/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-04-16 18:30:21
 * @LastEditors: changfeng
 * @LastEditTime: 2024-08-15 11:15:29
 */
export default {
	"action.button.next": "下一步",
	"action.button.back": "返回",
	"action.button.submit": "提交",
	"action.button.confirm": "确定",
	"action.button.update": "更新",
	"action.button.edit": "编辑",
	"action.button.cancel": "取消",
	"action.button.reset": "重置",
	"action.button.search": "搜索",
	"action.button.auth": "授权",
	"action.button.delete": "删除",
	"action.button.close": "关闭",

	"action.button.copy": "复制",
	"action.button.saveAsTemplate": "保存为模板",
	"action.button.use": "使用",
	"action.button.use to all": "应用到所有"
};
